export const ApiDef_MacroTag = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map